module.exports = __webpack_public_path__ + "img/antes_despues_110.5776edf4.png";